import { DiscountStatuses } from '../components/paymentJourneyRedesign/types/enums';

const NUMERIC_PART_REGEX = /[\d.,]+/;
const PROMOTION_CODE_APPLY_RESULT = 'PromotionCodeApplyResult';

export const isZeroDiscount = (discount?: string | null): boolean => {
  if (!discount) return false;

  const match = NUMERIC_PART_REGEX.exec(discount);

  if (!match) return false;

  return parseFloat(match[0].replace(',', '.')) === 0;
};

const isPromotionCodeSuccessStatus = (status?: string): boolean =>
  !!status &&
  (status.startsWith('VIP_') ||
    status === DiscountStatuses.withoutStatus ||
    status === DiscountStatuses.CODE_IS_APPLIED);

export const isZeroDiscountAndVipSuccess = (discountData?: {
  status?: string;
  success?: boolean;
  discount?: string | null;
}): boolean => {
  if (!discountData) return false;

  const { status, success, discount } = discountData;

  return (
    success === true &&
    isPromotionCodeSuccessStatus(status) &&
    isZeroDiscount(discount)
  );
};

export const mergeZeroValuePromotionIntoBasketResponse = (
  response: {
    statusCode?: number;
    json?: {
      meta?: {
        discountApplyResults?: Record<string, unknown>[];
        appliedCode?: string;
      };
    };
  },
  discountData: Record<string, unknown>,
  appliedCode: string,
): void => {
  if (
    !isZeroDiscountAndVipSuccess(discountData) ||
    response.statusCode !== 200 ||
    !response.json?.meta
  ) {
    return;
  }

  const discountApplyResults = response.json.meta.discountApplyResults || [];
  const hasPromotionResult = discountApplyResults.some(
    (result) => result['@type'] === PROMOTION_CODE_APPLY_RESULT,
  );

  if (hasPromotionResult) {
    return;
  }

  response.json.meta.discountApplyResults = [
    ...discountApplyResults,
    { '@type': PROMOTION_CODE_APPLY_RESULT, ...discountData },
  ];
  response.json.meta.appliedCode = appliedCode;
};
